"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
// import { isFragment } from 'react-is';
var clsx_1 = __importDefault(require("clsx"));
var style = __importStar(require("./SelectInput.style"));
var menu_1 = __importDefault(require("@prezzee/menu"));
var menu_item_1 = __importDefault(require("@prezzee/menu-item"));
var utils_1 = require("@prezzee/utils");
var utils_2 = require("@prezzee/utils");
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) {
        return a === b;
    }
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || (typeof display === 'string' && !display.trim());
}
var SelectIcon = function (_a) {
    var open = _a.open;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ css: style.icon(open), focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", "data-testid": "ArrowDropDownIcon" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M7 10l5 5 5-5z" }) })));
};
/**
 * @ignore - internal component.
 */
var SelectInput = (0, react_1.forwardRef)(function (props, ref) {
    var ariaDescribedby = props["aria-describedby"], ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, className = props.className, defaultOpen = props.defaultOpen, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _a = props.MenuProps, MenuProps = _a === void 0 ? {} : _a, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, _b = props.options, options = _b === void 0 ? [] : _b, readOnly = props.readOnly, renderValue = props.renderValue, _c = props.SelectDisplayProps, SelectDisplayProps = _c === void 0 ? {} : _c, tabIndexProp = props.tabIndex, 
    // catching `type` from Input which makes no sense for SelectInput
    // @ts-ignore
    type = props.type, valueProp = props.value, _d = props.variant, variant = _d === void 0 ? 'standard' : _d, rest = __rest(props, ['aria-describedby', 'aria-label', "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "options", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
    var _e = __read((0, utils_2.useControlled)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select',
    }), 2), value = _e[0], setValueState = _e[1];
    var _f = __read((0, utils_2.useControlled)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select Open',
    }), 2), openState = _f[0], setOpenState = _f[1];
    var inputRef = (0, react_1.useRef)(null);
    var displayRef = (0, react_1.useRef)(null);
    var _g = __read((0, react_1.useState)(null), 2), displayNode = _g[0], setDisplayNode = _g[1];
    var isOpenControlled = (0, react_1.useRef)(openProp != null).current;
    var _h = __read((0, react_1.useState)(null), 2), menuMinWidthState = _h[0], setMenuMinWidthState = _h[1];
    var handleRef = (0, utils_2.useForkRef)(ref, inputRefProp);
    var handleDisplayRef = (0, react_1.useCallback)(function (node) {
        displayRef.current = node;
        if (node) {
            setDisplayNode(node);
        }
    }, []);
    (0, react_1.useImperativeHandle)(handleRef, function () { return ({
        focus: function () {
            var _a;
            (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        },
        node: inputRef.current,
        value: value,
    }); }, [value]);
    // Resize menu on `defaultOpen` automatic toggle.
    (0, react_1.useEffect)(function () {
        var _a;
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayNode, autoWidth]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    (0, react_1.useEffect)(function () {
        var _a;
        if (autoFocus) {
            (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [autoFocus]);
    (0, react_1.useEffect)(function () {
        if (!labelId) {
            return undefined;
        }
        var label = (0, utils_2.ownerDocument)(displayRef.current).getElementById(labelId);
        if (label) {
            var handler_1 = function () {
                var _a, _b;
                if ((_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.isCollapsed) {
                    (_b = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                }
            };
            label.addEventListener('click', handler_1);
            return function () {
                label.removeEventListener('click', handler_1);
            };
        }
        return undefined;
    }, [labelId]);
    var update = function (open, event) {
        if (open) {
            if (onOpen) {
                onOpen(event);
            }
        }
        else if (onClose) {
            onClose(event);
        }
        if (!isOpenControlled && displayNode) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function (event) {
        var _a;
        // Ignore everything but left-click
        if (event.button !== 0) {
            return;
        }
        // Hijack the default focus behavior.
        event.preventDefault();
        (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        update(true, event);
    };
    // TODO: fix type
    var handleClose = function (event) {
        update(false, event);
    };
    var childrenArray = react_1.Children.toArray(children);
    // Support autofill.
    // TODO: fix type
    var handleChange = function (event) {
        var index = childrenArray.map(function (child) { return child.props.value; }).indexOf(event.target.value);
        if (index === -1) {
            return;
        }
        var child = childrenArray[index];
        setValueState(child.props.value);
        if (onChange) {
            onChange(event, child);
        }
    };
    // TODO: fix type
    var handleItemClick = function (option) { return function (event) {
        var newValue;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            var itemIndex = value.indexOf(option.value);
            if (itemIndex === -1) {
                newValue.push(option.value);
            }
            else {
                newValue.splice(itemIndex, 1);
            }
        }
        else {
            newValue = option.value;
        }
        if (value !== newValue) {
            setValueState(newValue);
            if (onChange) {
                // Redefine target to allow name and value to be read.
                // This allows seamless integration with the most popular form libraries
                // Clone the event to not override `target` of the original event.
                var nativeEvent = event.nativeEvent || event;
                var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                Object.defineProperty(clonedEvent, 'target', {
                    writable: true,
                    value: { value: newValue, name: name },
                });
                onChange(clonedEvent);
            }
        }
        if (!multiple) {
            update(false, event);
        }
    }; };
    var handleKeyDown = function (event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on MacOS, but it's recommended by
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter',
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && openState;
    var handleBlur = function (event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', { writable: true, value: { value: value, name: name } });
            onBlur(event);
        }
    };
    delete rest['aria-invalid'];
    var display;
    var displaySingle;
    // TODO: fix type
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, utils_1.isFilled)({ value: value }) || displayEmpty) {
        if (renderValue) {
            display = renderValue(value);
        }
        else {
            computeDisplay = true;
        }
    }
    var items = options.map(function (option, index) {
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) {
                throw new Error('The `value` prop must be an array ' +
                    'when using the `Select` component with `multiple`.');
            }
            selected = value.some(function (v) { return areEqualValues(v, option.value); });
            if (selected && computeDisplay) {
                displayMultiple.push(option.label ? option.label : option.value);
            }
        }
        else {
            selected = areEqualValues(value, option.value);
            if (selected && computeDisplay) {
                displaySingle = option.label ? option.label : option.value;
            }
        }
        if (selected) {
            foundMatch = true;
        }
        if (option.value === undefined) {
            return ((0, jsx_runtime_1.jsx)(menu_item_1.default, __assign({ "aria-readonly": true, role: "option" }, { children: option.label ? option.label : option.value }), index));
        }
        return ((0, jsx_runtime_1.jsx)(menu_item_1.default, __assign({ "aria-selected": selected ? true : false, onClick: handleItemClick(option), onKeyUp: function (event) {
                if (event.key === ' ') {
                    // otherwise our MenuItems dispatches a click event
                    // it's not behavior of the native <option> and causes
                    // the select to close immediately since we open on space keydown
                    event.preventDefault();
                }
            }, role: "option", 
            // @ts-ignore
            selected: selected, value: undefined, "data-value": value }, { children: option.label ? option.label : option.value }), index));
    });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, react_1.useEffect)(function () {
            if (!foundMatch && !multiple && value !== '' && value) {
                var values = childrenArray.map(function (child) { return child.props.value; });
                console.warn([
                    "You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."),
                    "Consider providing a value that matches one of the available options or ''.",
                    "The available values are ".concat(values
                        .filter(function (x) { return x != null; })
                        .map(function (x) { return "`".concat(x, "`"); })
                        .join(', ') || '""', "."),
                ].join('\n'));
            }
        }, [foundMatch, childrenArray, multiple, name, value]);
    }
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) {
                display = null;
            }
            else {
                display = displayMultiple.reduce(function (output, child, index) {
                    output.push(child);
                    if (index < displayMultiple.length - 1) {
                        output.push(', ');
                    }
                    return output;
                }, []);
            }
        }
        else {
            display = displaySingle;
        }
    }
    // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) {
        menuMinWidth = displayNode.clientWidth;
    }
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
    }
    else {
        tabIndex = disabled ? undefined : 0;
    }
    var buttonId = SelectDisplayProps.id || (name ? "prezzee-component-select-".concat(name) : undefined);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ ref: handleDisplayRef, tabIndex: tabIndex, role: "button", "aria-disabled": disabled ? 'true' : undefined, "aria-expanded": open ? 'true' : 'false', "aria-haspopup": "listbox", "aria-label": ariaLabel, "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined, "aria-describedby": ariaDescribedby, onKeyDown: handleKeyDown, onMouseDown: disabled || readOnly ? undefined : handleMouseDown, onBlur: handleBlur, onFocus: onFocus }, SelectDisplayProps, { css: style.container, className: (0, clsx_1.default)(className, SelectDisplayProps.className), 
                // The id is required for proper a11y
                id: buttonId }, { children: isEmpty(display) ? (
                // notranslate needed while Google Translate will not fix zero-width space issue
                (0, jsx_runtime_1.jsx)("span", __assign({ className: "notranslate" }, { children: "\u200B" }))) : (display) })), (0, jsx_runtime_1.jsx)("input", __assign({ value: Array.isArray(value) ? value.join(',') : value, name: name, ref: inputRef, "aria-hidden": true, onChange: handleChange, tabIndex: -1, disabled: disabled, autoFocus: autoFocus }, rest, { css: style.nativeSelect })), (0, jsx_runtime_1.jsx)(SelectIcon, { open: open }), (0, jsx_runtime_1.jsx)(menu_1.default, __assign({ id: "menu-".concat(name || ''), anchorEl: displayNode, open: open, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, MenuProps, { MenuListProps: __assign({ 'aria-labelledby': labelId, role: 'listbox', disableListWrap: true }, MenuProps.MenuListProps), PaperProps: __assign(__assign({}, MenuProps.PaperProps), { style: __assign({ minWidth: menuMinWidth }, (MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)) }) }, { children: items }))] }));
});
exports.default = SelectInput;
//# sourceMappingURL=SelectInput.js.map